import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  jobCenterData: null,
};

const jobCenterSlice = createSlice({
  name: 'jobCenterSlice',
  initialState,
  reducers: {
    setJobCenterData: (state, action) => {
      state.jobCenterData = action.payload;
    },
  },
});

export const {
  setJobCenterData,
} = jobCenterSlice.actions;

export default jobCenterSlice.reducer;
